export class MockUrlService {
  get = jasmine.createSpy('get');
}
